"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _request = _interopRequireDefault(require("../../request"));
var _default = exports.default = {
  getTaskAllocatedList: function getTaskAllocatedList(data) {
    return (0, _request.default)({
      url: "/protected/taskAllocated/list",
      method: 'post',
      data: data
    });
  },
  exportTaskAllocated: function exportTaskAllocated(data, cancelToken) {
    return (0, _request.default)({
      url: "/protected/taskAllocated/export",
      method: 'post',
      data: data,
      cancelToken: cancelToken,
      responseType: 'blob'
    });
  },
  getTaskDescriptionList: function getTaskDescriptionList(data) {
    return (0, _request.default)({
      url: "/protected/taskAllocated/taskDescriptionList",
      method: 'post',
      data: data
    });
  },
  importTaskAllocated: function importTaskAllocated(data, cancelToken) {
    return (0, _request.default)({
      url: "/protected/taskAllocated/import",
      method: 'post',
      data: data,
      cancelToken: cancelToken
    });
  }
};